export default __webpack_public_path__ + "static/media/SFProText-Regular.f7a53604.ttf";